import { useState } from 'react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Spinner } from '@/components/ui/spinner';
import { Textarea } from '@/components/ui/textarea';

interface EscritorioFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Sem `inicial`, é a criação. */
  inicial?: { nome: string; descricao?: string | null };
  salvando: boolean;
  onSalvar: (dados: { nome: string; descricao?: string }) => void;
}

/** Criar ou editar o escritório: nome e descrição. */
export function EscritorioFormDialog(props: EscritorioFormDialogProps) {
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent className="sm:max-w-md">
        {/* Montado a cada abertura: o formulário nasce dos valores atuais, sem efeito. */}
        {props.open && <Formulario {...props} />}
      </DialogContent>
    </Dialog>
  );
}

function Formulario({ onOpenChange, inicial, salvando, onSalvar }: EscritorioFormDialogProps) {
  const [nome, setNome] = useState(inicial?.nome ?? '');
  const [descricao, setDescricao] = useState(inicial?.descricao ?? '');
  const criando = !inicial;
  return (
    <>
      <DialogHeader>
        <DialogTitle>{criando ? 'Novo escritório' : 'Editar escritório'}</DialogTitle>
        <DialogDescription>
          {criando
            ? 'Crie o escritório e convide os colegas: cada um escolhe o que compartilha com o grupo.'
            : 'O nome e a descrição aparecem para todos os membros.'}
        </DialogDescription>
      </DialogHeader>
      <form
        className="space-y-4"
        onSubmit={(e) => {
          e.preventDefault();
          if (nome.trim())
            onSalvar({
              nome: nome.trim(),
              descricao: criando ? descricao.trim() || undefined : descricao.trim(),
            });
        }}
      >
        <div className="space-y-2">
          <Label htmlFor="escritorio-nome">Nome do escritório</Label>
          <Input
            id="escritorio-nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            placeholder="Ex.: Silva & Associados"
            autoFocus
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="escritorio-descricao">Descrição (opcional)</Label>
          <Textarea
            id="escritorio-descricao"
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
            rows={3}
          />
        </div>
        <DialogFooter>
          <Button type="button" variant="ghost" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button type="submit" disabled={salvando || !nome.trim()}>
            {salvando && <Spinner size={16} className="mr-2 text-inherit" />}
            {criando ? 'Criar escritório' : 'Salvar'}
          </Button>
        </DialogFooter>
      </form>
    </>
  );
}
